var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetOneClientRfpShareDocumentMessageFile } from '@/actions/ClientRfpShareDocumentActions';
import { notifyError } from '@/helpers/action';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { openFileNewTab } from '@/utils/file/open';
/**
 * クライアント：提案書共有メッセージファイルのダウンロード処理
 * @returns
 */
export const useRfpClientShareDocumentMessageFile = (args) => {
    const { dispatch, id, unmountRef } = args;
    /**
     * ファイルダウンロードを実行
     */
    const onClickFileLink = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { value } = event.currentTarget;
            const { payload } = yield wrapDispatch(dispatch, apiGetOneClientRfpShareDocumentMessageFile({ path: { id, share_document_message_file_id: value } }, {}));
            if (!unmountRef.current) {
                openFileNewTab(payload.url);
            }
        }
        catch (error) {
            if (!unmountRef.current) {
                notifyError('ファイルの取得中にエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。');
            }
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }), [dispatch, id, unmountRef]);
    return {
        onClickFileLink,
    };
};
